import { render, staticRenderFns } from "./memberList.vue?vue&type=template&id=037241c2&scoped=true"
import script from "./memberList.vue?vue&type=script&lang=js"
export * from "./memberList.vue?vue&type=script&lang=js"
import style0 from "./memberList.vue?vue&type=style&index=0&id=037241c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037241c2",
  null
  
)

export default component.exports